<!-- client/src/components/icons/AmazonMusic.vue -->
<template>
  <span
    class="icon"
    :style="maskStyle"
    aria-hidden="true"
  />
</template>

<script setup>
import { computed } from 'vue'
import amazonIcon from '@/assets/icons/amazon.svg'

const maskStyle = computed(() => ({
  WebkitMask: `url(${amazonIcon}) center / 90% no-repeat`,
  mask: `url(${amazonIcon}) center / 90% no-repeat`
}))
</script>

<style scoped>
.icon {
  width: 24px;
  height: 24px;
  display: inline-block;
  background-color: currentColor;
}
</style>
